import firebase from 'firebase/app';
import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireStorage } from 'angularfire2/storage';

@Injectable()

export class TentativeRealEstateService {
    public addiApplicant: any;
    constructor(
        public db: AngularFirestore,
        public afAuth:AngularFireAuth,
       
    ) { 
        
    }
    addUpdateTentativeRealEstate(request){
        console.log('5', request);
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
            console.log(request)
            const thiss = this;
            if(request.realEstateForm.length > 0){
                let group_id = new Date().getTime()
                for(let i = 0; i < request.realEstateForm.length; i++){
                    if(request.realEstateForm[0].group_id == "" || request.realEstateForm[0].group_id == null || request.realEstateForm[0].group_id == undefined){}else{
                        group_id = request.realEstateForm[0].group_id;
                    }
                    thiss.addUpdateRealAssets(request.realEstateForm[i], request.primary_uid, request.document_id, group_id);
                }
            }           
        }
    }

    addUpdateRealAssets(data, uid, SDF_form_id, group_id){
        const thiss = this;
        const timestamp = new Date().getTime();
        console.log('group_id', group_id)
        const docRef = this.db.collection('/tentative_real_estate');
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){
            docRef.doc(uid+'_'+timestamp).set({
                address_format : (data.address_format == null) ? '' : data.address_format,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                building_name : (data.building_name == null) ? '' : data.building_name,
                city : (data.city == null) ? '' : data.city,
                country : (data.country == null) ? 0 : data.country,
                floor_number : (data.floor_number == null) ? '' : data.floor_number,
                gross_amount : (data.gross_amount == null) ? '' : data.gross_amount.split("$").join("").split(",").join(""),
                notes : (data.notes == null) ? '' : data.notes,
                ownership_title_name : (data.ownership_title_name == null) ? 0 : data.ownership_title_name,
                postcode : (data.postcode == null) ? '' : data.postcode,
                primary_percentage_asset : (data.primary_percentage_asset == null) ? '' : data.primary_percentage_asset,
                secondary_percentage_asset_0 : (data.secondary_percentage_asset_0 == null) ? '' : data.secondary_percentage_asset_0,
                secondary_percentage_asset_1 : (data.secondary_percentage_asset_1 == null) ? '' : data.secondary_percentage_asset_1,
                secondary_percentage_asset_2 : (data.secondary_percentage_asset_2 == null) ? '' : data.secondary_percentage_asset_2,
                secondary_percentage_asset_3 : (data.secondary_percentage_asset_3 == null) ? '' : data.secondary_percentage_asset_3,
                secondary_percentage_asset_4 : (data.secondary_percentage_asset_4 == null) ? '' : data.secondary_percentage_asset_4,
                state : (data.state == null) ? '' : data.state,
                street_name : (data.street_name == null) ? '' : data.street_name,
                street_number : (data.street_number == null) ? '' : data.street_number,
                street_type : (data.street_type == null) ? '' : data.street_type,
                unit_number : (data.unit_number == null) ? '' : data.unit_number,
                value_basis : (data.value_basis == null) ? '' : data.value_basis,
                split: data.itemRowsMortgageSplits,
                SDF_form: SDF_form_id,
                created_date: timestamp,
                uid: uid,
                deleted: 0,
                group_id : group_id,
                document_id: uid+'_'+timestamp
            }).then(function(response) {
                thiss.createSplitInRealEstate(data, uid, timestamp);
            })
            .catch(err => {
                return false;
            });
        }else{
            docRef.doc(data.document_id).update({
                address_format : (data.address_format == null) ? '' : data.address_format,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                building_name : (data.building_name == null) ? '' : data.building_name,
                city : (data.city == null) ? '' : data.city,
                country : (data.country == null) ? 0 : data.country,
                floor_number : (data.floor_number == null) ? '' : data.floor_number,
                gross_amount : (data.gross_amount == null) ? '' : data.gross_amount.split("$").join("").split(",").join(""),
                notes : (data.notes == null) ? '' : data.notes,
                ownership_title_name : (data.ownership_title_name == null) ? 0 : data.ownership_title_name,
                postcode : (data.postcode == null) ? '' : data.postcode,
                primary_percentage_asset : (data.primary_percentage_asset == null) ? '' : data.primary_percentage_asset,
                secondary_percentage_asset_0 : (data.secondary_percentage_asset_0 == null) ? '' : data.secondary_percentage_asset_0,
                secondary_percentage_asset_1 : (data.secondary_percentage_asset_1 == null) ? '' : data.secondary_percentage_asset_1,
                secondary_percentage_asset_2 : (data.secondary_percentage_asset_2 == null) ? '' : data.secondary_percentage_asset_2,
                secondary_percentage_asset_3 : (data.secondary_percentage_asset_3 == null) ? '' : data.secondary_percentage_asset_3,
                secondary_percentage_asset_4 : (data.secondary_percentage_asset_4 == null) ? '' : data.secondary_percentage_asset_4,
                state : (data.state == null) ? '' : data.state,
                street_name : (data.street_name == null) ? '' : data.street_name,
                street_number : (data.street_number == null) ? '' : data.street_number,
                street_type : (data.street_type == null) ? '' : data.street_type,
                unit_number : (data.unit_number == null) ? '' : data.unit_number,
                value_basis : (data.value_basis == null) ? '' : data.value_basis,
                split: data.itemRowsMortgageSplits,
                group_id : group_id
            }).then(function(response) {
                thiss.createSplitInRealEstate(data, uid, timestamp);
            })
            .catch(err => {
                return false;
            });
        }
    }

    createSplitInRealEstate(data, uid, timestamp){
        const docRef = this.db.collection('tentative_real_estate').doc(uid+'_'+timestamp).collection('mortgage_splits');
        for(let l = 0; l < data.itemRowsMortgageSplits.length; l++){
            const randN1 = new Date().getTime();
            docRef.doc('msd_'+l+'_'+randN1).set({
                creditor : data.itemRowsMortgageSplits[l].creditor,
                mortgage_limit : data.itemRowsMortgageSplits[l].mortgage_limit.split("$").join("").split(",").join(""),
                current_balance : data.itemRowsMortgageSplits[l].current_balance.split("$").join("").split(",").join(""),
                available_redraw : (data.itemRowsMortgageSplits[l].mortgage_limit.split("$").join("").split(",").join("") - data.itemRowsMortgageSplits[l].current_balance.split("$").join("").split(",").join("")),
                repayments : data.itemRowsMortgageSplits[l].repayments.split("$").join("").split(",").join(""),
                interest_rate : data.itemRowsMortgageSplits[l].interest_rate.split(" ").join(""),
                interest_rate_term : data.itemRowsMortgageSplits[l].interest_rate_term,
                loan_type : data.itemRowsMortgageSplits[l].loan_type,
                created_date: randN1,
                document_id : 'msd_'+l+'_'+randN1,
                deleted : 0
            });  
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/tentative-real-estate-service.ts